import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { TeamCost } from '../types';

type Body = {
  info?: string;
  note?: string;
  datReg?: string;
  price?: string;
  costListId?: string;
  travelFrom?: Date | string;
  travelTo?: Date | string;
  amount?: string;
  proposedQ?: string;
  lunchFactor?: boolean;
};

export const updateAuditorVisitCostId = async ({
  visitCostId,
  data,
}: {
  visitCostId: string;
  data: Body;
}): Promise<TeamCost> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/costs/${visitCostId}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as TeamCost;
  return response;
};
